import Avatar1 from '../assets/avatar-1.png'
import Avatar2 from '../assets/avatar-2.png'
import Avatar3 from '../assets/avatar-3.png'
import Avatar4 from '../assets/avatar-4.png'
import Avatar5 from '../assets/avatar-5.png'
import Avatar6 from '../assets/avatar-6.png'
import Avatar7 from '../assets/avatar-7.png'
import Avatar8 from '../assets/avatar-8.png'

export const AvatarEnum = ['', Avatar1, Avatar2, Avatar3, Avatar4, Avatar5, Avatar6, Avatar7, Avatar8]
